import React, {useState, useRef, useEffect} from 'react';
import {message, Upload} from 'antd';
import {clickBgUploadLog} from '../../../../log/ubcLog';
import iconAdd from '../../../../assets/images/icon_add.png';
import iconDel from '../../../../assets/images/icon_shadow_close.png';
import iconLoading from '../../../../assets/images/icon_loading2.png';

let hoverTimer;

const VideoItem = props => {
    const {name, url, poster, type, bgTab, id, compress_status: compressStatus = 2, compress_status_msg: compressMsg,
        onSelect, opt, onUpload, onDel, videoUploading, uploadProcess} = props;
    const {delApi} = opt || {};

    const [materialSize, setMaterialSize] = useState({});
    const [showDelMask, setShowDelMask] = useState(false);
    const [showVideo, setShowVideo] = useState(false);

    const del = async e => {
        e.stopPropagation();

        typeof onDel === 'function' && onDel(id);
        setShowDelMask(false);
    };

    const cancel = e => {
        e.stopPropagation();
        setShowDelMask(false);
    };

    const onClickDel = e => {
        e.stopPropagation();

        setShowDelMask(true);
    };

    const onClick = e => {
        if (compressStatus !== 0 && compressStatus !== 2) {
            message.warn('视频压缩处理中，暂不可用，请稍后重试');
            return;
        }
        onSelect({...props, materialSize});
    };

    const onMouseEnter = e => {
        hoverTimer = setTimeout(() => {
            setShowVideo(true);
        }, 300);
    };

    const onMouseLeave = e => {
        clearTimeout(hoverTimer);
        setShowVideo(false);
    };

    const handleUpload = e => {
        clickBgUploadLog('bg_video');
        onUpload(e);
    };

    if (type === 'add') {
        return (
            <div className="digital-resource-lib-item video-item">
                {
                    videoUploading
                        ? (
                            <div className="video-item-imgwrapper add uploading">
                                <div className="video-item-upload-process">
                                    <div
                                        className="video-item-upload-process-bar"
                                        style={{width: `${uploadProcess}%`}}
                                    />
                                </div>
                                上传中  {uploadProcess}%
                            </div>
                        )
                        : (
                            <Upload
                                customRequest={handleUpload}
                                showUploadList={false}
                                accept={opt.fileFilter || 'image/png,image/jpeg,image/jpg'}
                            >
                                <div className="image-item-imgwrapper add">
                                    <img className="icon icon-add" src={iconAdd} />
                                    <p className="add-text">本地文件上传</p>
                                </div>
                            </Upload>
                        )
                }
            </div>
        );
    }

    return (
        <div className="digital-resource-lib-item video-item" onClick={onClick}>
            <div
                className="video-item-imgwrapper"
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <img className="video-item-bg" src={poster} />
                {showVideo ? (
                    <video
                        muted
                        autoPlay
                        className="video-item-video"
                        src={url}
                    />
                ) : null}
                {compressStatus !== 0 && compressStatus !== 2
                    ? (
                        <div className="video-item-disable-mask">
                            <img className="icon icon-loading" src={iconLoading} />
                            {compressMsg}
                        </div>
                    )
                    : null}
                {delApi && !showDelMask ? <img className="icon icon-del" src={iconDel} onClick={onClickDel} /> : null}
                {showDelMask ? (
                    <div className="video-item-del-mask">
                        <p className="video-item-del-mask-title">确认删除吗?</p>
                        <div className="row">
                            <p className="video-item-del-mask-btn" onClick={cancel}>取消</p>
                            <p className="video-item-del-mask-btn" onClick={del}>确认</p>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default VideoItem;
